'use client';

import React, { useEffect, useRef, useState } from 'react';
import { bubbleTestimony } from '@/constants';

export const BubbleChatList = () => {
    const scrollRef = useRef<HTMLDivElement>(null);
    const bubbleRef = useRef<HTMLDivElement>(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const [bubbleVisible, setBubbleVisible] = useState(false);

    const scroll = (direction: 'left' | 'right') => {
        if (scrollRef.current) {
            const scrollAmount = 320;
            scrollRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth',
            });

            setTimeout(updateScrollButtons, 400);
        }
    };

    const updateScrollButtons = () => {
        if (scrollRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
            setCanScrollLeft(scrollLeft > 0);
            setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
        }
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) setBubbleVisible(true);
                });
            },
            { threshold: 0.3 }
        );

        const currentBubble = bubbleRef.current;
        if (currentBubble) observer.observe(currentBubble);

        return () => {
            if (currentBubble) observer.unobserve(currentBubble);
        };
    }, []);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        updateScrollButtons();

        el.addEventListener('scroll', updateScrollButtons);
        window.addEventListener('resize', updateScrollButtons);

        return () => {
            el.removeEventListener('scroll', updateScrollButtons);
            window.removeEventListener('resize', updateScrollButtons);
        };
    }, []);

    return (
        <div
            ref={bubbleRef}
            className={`transition-opacity duration-1000 mt-10 px-4 md:px-12 ${bubbleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
        >
            <div className="relative">
                <div ref={scrollRef} className="overflow-x-auto scrollbar-hide">
                    <div className="flex gap-4 w-max py-4 px-2 md:px-0">
                        {bubbleTestimony.map((item, index) => (
                            <div
                                key={index}
                                className="relative bg-[rgb(13,148,136)] text-white text-sm rounded-2xl px-4 py-3 shadow-md max-w-[85vw] md:max-w-xs w-full shrink-0"
                            >
                                <span className="absolute -left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 bg-[rgb(13,148,136)] rotate-45 rounded-sm shadow-md"></span>
                                <p className="italic">
                                    {item.testimony.length > 100
                                        ? item.testimony.slice(0, 100) + '...'
                                        : item.testimony}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
                {canScrollLeft && (
                    <button
                        onClick={() => scroll('left')}
                        className="absolute left-0 top-1/2 -translate-y-1/2 bg-white text-black rounded-full shadow-md border-2 z-10 hover:bg-gray-200 w-8 h-8 flex items-center justify-center"
                    >
                        <img src="/img/home/left-arrow.png" alt="Kiri" />
                    </button>
                )}
                {canScrollRight && (
                    <button
                        onClick={() => scroll('right')}
                        className="absolute right-0 top-1/2 -translate-y-1/2 bg-white text-black rounded-full shadow-md border-2 z-10 hover:bg-gray-200 w-8 h-8 flex items-center justify-center"
                    >
                        <img src="/img/home/right-arrow.png" alt="Kanan" />
                    </button>
                )}
            </div>
        </div>
    );
};
